import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import { Text, Box } from 'components/ui';
import checkoutUtils from 'utils/Checkout';
import { SKU_TYPE } from 'constants/frictionlessCheckout';
import PromiseDateAndItems from 'components/FrictionlessCheckout/ShippingMethods/PromiseDateAndItems/PromiseDateAndItems';

const { FULLFILLMENT_TYPE } = checkoutUtils;

function GetItShippedShippingGroups(props) {
    const {
        locales: { getItShipped, items },
        standardItemsQuantity,
        isPhysicalGiftCard,
        electronicShippingGroup,
        standardBasketItems,
        shippingMethod,
        deliveryGroups,
        isEditView
    } = props;

    const showSplitEDD = (deliveryGroups?.length || 0) > 0;
    const cutOffDescriptionForSplitEdd = showSplitEDD && !isPhysicalGiftCard && shippingMethod?.promiseDateSplitCutOffDescription;
    const GISDeliveryGroups = showSplitEDD ? checkoutUtils.seperateItemsinDeliveryGroupByFullfullment(deliveryGroups, FULLFILLMENT_TYPE.GIS) : [];
    const ARDeliveryGroups = showSplitEDD ? checkoutUtils.seperateItemsinDeliveryGroupByFullfullment(deliveryGroups, FULLFILLMENT_TYPE.AR) : [];
    const deliveryMethods = showSplitEDD ? GISDeliveryGroups : [shippingMethod];
    const allGISItems = shippingMethod?.items || [];
    const getItemKey = item => item?.sku?.skuId || item?.skuId || item?.commerceId || item?.catalogRefId;
    const getGroupedSkuIds = groups => new Set((groups || []).flatMap(group => (group?.items || []).map(getItemKey)).filter(Boolean));
    const groupedSkuIds = getGroupedSkuIds(GISDeliveryGroups);
    const arGroupedSkuIds = getGroupedSkuIds(ARDeliveryGroups);
    const fallbackCandidates = [...(standardBasketItems || []), ...allGISItems];
    const extraGISItems = fallbackCandidates
        .filter((item, index, candidates) => {
            const itemKey = getItemKey(item);

            if (!itemKey) {
                return candidates.indexOf(item) === index;
            }

            return candidates.findIndex(candidate => getItemKey(candidate) === itemKey) === index;
        })
        .filter(item => {
            const itemKey = getItemKey(item);

            return !itemKey || (!arGroupedSkuIds.has(itemKey) && !groupedSkuIds.has(itemKey));
        });

    return (
        <>
            <Text
                is='h4'
                fontWeight='bold'
                children={`${getItShipped} • ${items} (${standardItemsQuantity})`}
            />
            {deliveryMethods.map((deliveryMethod, index) => (
                <Box {...(showSplitEDD && { marginBottom: index !== deliveryGroups.length - 1 && 4 })}>
                    <PromiseDateAndItems
                        shippingMethod={deliveryMethod}
                        {...(index === 0 && {
                            extraItems: [...(electronicShippingGroup?.items || []), ...extraGISItems].filter(
                                item => item?.sku?.type !== SKU_TYPE.GIFT_CARD
                            )
                        })}
                        isEditView={isEditView}
                        standardOnly={true}
                        {...(showSplitEDD && {
                            showSplitEDD,
                            cutOffDescriptionForSplitEdd
                        })}
                    />
                </Box>
            ))}
        </>
    );
}

export default wrapFunctionalComponent(GetItShippedShippingGroups, 'GetItShippedShippingGroups');
